import React from 'react';
import styled from "styled-components";
import {Accordion} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import {BsChevronDown} from "react-icons/bs";
import {Img} from "../Img";
import {darkBlue, hover, semibold, text} from "../../styles/globalStyleVars"
import Social from "../Social";
import ReactHtmlParser from "react-html-parser";



const Accordions = ({data}) => {
    return (
        <StyledAddress className='address'>
            <div className={`address__accordion`} sm={12}>

                <Accordion defaultActiveKey="0">
                    {
                        data && data?.length>0 &&
                        data?.map((element,index)=>{
                            return(
                                <Accordion.Item key={index} eventKey={`${index}`}>
                                    <Accordion.Header>
                                        <div>{reactHtmlParser(element?.title)}</div>
                                        <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="7.414" height="4.414" viewBox="0 0 7.414 4.414">
                                    <g id="Group_15708" data-name="Group 15708" transform="translate(0.707 3.707) rotate(-90)">
                                      <line id="Line_7" data-name="Line 7" x2="3" y2="3" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                                      <line id="Line_8" data-name="Line 8" y1="3" x2="3" transform="translate(0 3)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                                    </g>
                                </svg>
                            </span>
                                    </Accordion.Header>
                                    <Accordion.Body>

                                        <div className="contact-numbers ">
                                            <div className={'wrapper-single-item'}>
                                                <p>{element?.address_title}</p>
                                                <a target={'_blank'} href={element?.gmap_url}>
                                                    {reactHtmlParser(element?.address)}
                                                </a>
                                            </div>
                                            <div className="wrapper-single-item">

                                            </div>

                                            <div className="wrapper-single-item">
                                                <p>{element?.phone_title}</p>
                                                <ul>
                                                    {ReactHtmlParser(element?.phone)}
                                                    {/*<li><a href="tel:+880 1111 222 333">+880 1111 222 333</a></li>*/}
                                                    {/*<li><a href="tel:+88-02-48810551">+880 1111 222 333</a></li>*/}
                                                    {/*<li><a href="tel:+880 1111 222 333">+880 1111 222 333</a></li>*/}
                                                </ul>
                                            </div>
                                            <div className="wrapper-single-item">
                                                <p>{element?.email_name}</p>
                                                <ul>
                                                    <li><a href={`mailto:${element?.email_address}`}>{element?.email_address}</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="map">
                                            <a target={'_blank'} href={element?.gmap_url}>
                                                <div className="img-wrap">
                                                    <iframe src={element?.image} width="100%" height="100%" frameborder="0" loading="lazy" style={{border: "0px"}}></iframe>
                                                </div>
                                            </a>
                                        </div>

                                    </Accordion.Body>
                                </Accordion.Item>
                            )

                        })
                    }

                </Accordion>
            </div>
        </StyledAddress>
    );
};


const StyledAddress = styled.section`

  .accordion-item {
    margin-bottom: 40px;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }

  .accordion-header {
    position: relative;
    margin: 0;
    font-size: unset;
    line-height: unset;
    
    button {
      border: none;
      background-color: transparent;
      padding-left: 0;
      color: ${hover};
      padding-bottom: 20px;
      border-bottom: 1px solid ${hover};
      width: 100%;
      text-align: left;
      transition: all .4s ease;
      font-size: 16px;
      line-height: 20px;
      font-family: ${semibold};
      
      &.collapsed {
        color: #1A1818;
        border-color: #1A1818;

        span {
          background-color: black;

          svg {
            transform: rotate(0deg);
          }

          &:after {
            background-color: ${hover} !important;
          }
        }
      }
    }

    span {
      position: absolute;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      color: #ffffff;
      background-color: ${hover};
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      bottom: 16px;

      &:after {
        height: 0;
        width: 0;
        background-color: ${hover};
        border-radius: 50%;
        opacity: 0;
        transition: all .4s ease;
        content: '';
        position: absolute;
      }

      svg {
        font-size: 13px;
        z-index: 2;
        transform: rotate(180deg);
      }

    }

    &:hover {
      span {
        &:after {
          height: 100%;
          width: 100%;
          opacity: 1;
        }
      }

      button {
        color: ${hover};
        border-color: ${hover};
      }
    }
  }

  .accordion-body {
    padding-top: 40px;

    p, a {
      font-size: 16px;
      line-height: 24px;
      //font-weight: 500;
      color: ${text};
      b{
        color: ${darkBlue};
      }
    }
    p{
      margin-bottom: 9px;
    }
    a {
      color: ${darkBlue};
    }

    .contact-numbers {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .wrapper-single-item {
        flex: 0 0 calc(50% - 30px);
        margin-bottom: 40px;
        
      }

      ul {
        li {
          a {
            margin-bottom: 10px;
            display: flex;

            span {
              font-size: 26px;
              font-weight: bold;
              line-height: 32px;
              transition: .3s ease;
            }

            &:hover span {
              color: red;
            }
          }

          &:nth-last-of-type(1) {
            margin-bottom: 0;
          }
        }
      }
    }

    .map {

      .img-wrap {
        position: relative;
        overflow: hidden;
        padding-top: calc(300 / 570 * 100%);
          iframe {
              width: 100%;
              height: 100%;
              object-fit: cover;
              position: absolute;
              inset: 0px;
          }
      }
    }
  }


  .address__form {

    .form-control {
      font-size: 16px;
      line-height: 22px;
      border: none;
      background-color: transparent;
      border-bottom: 1px solid black;
      border-radius: 0;
      padding-left: 0;
      padding-bottom: 20px;
      margin-bottom: 40px;

      &::placeholder {
        color: rgba(34, 31, 31, 0.5) !important;
        font-size: 16px;
        line-height: 22px;
        font-weight: 300;
      }
    }

    textarea {
      min-height: 90px;
      max-height: 90px;
      min-width: 100%;
      max-width: 100%;
      margin-bottom: 60px;
    }

    .divider {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .form-control {
        width: calc(50% - 15px);
      }
    }

    &__title {
      margin-bottom: 60px;

      h5 {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 20px;
        font-weight: 600;
      }

      p {
        font-size: 26px;
        font-weight: bold;
        line-height: 32px;
      }
    }
  }

  @media (max-width: 768px) {
    .address__accordion {
      min-width: 100%;
    }

    .address__form {
      min-width: 100%;
      margin-top: 60px;
    }
  }

  @media (max-width: 767px) {

    .address__row {
      flex-direction: column-reverse;
    }

    .address__form {
      margin-top: 0;
      margin-bottom: 60px;
    }

    .contact-numbers {
      flex-wrap: wrap;

      .col-sm-4 {
        min-width: 50%;

        &:nth-last-child(1) {
          margin-top: 30px;
          padding-left: 0;
        }
      }
    }
  }

`;


export default React.memo(Accordions);